<template>
	<header class="header-main-top">
		<div class="header-main d-flex justify-content-between align-items-center">
			<div class="d-flex">
				<div class="cv-logo mr-2 ml-3 pointer d-flex align-items-center">
					<img
						src="https://cvstaticfiles.s3.ap-south-1.amazonaws.com/Hire3xAssests/Logo/SVG/Hire3xbeta_logo.svg"
						alt=""
					/>
				</div>
			</div>
		</div>
	</header>
</template>
<script>
export default {
	name: "",
	components: {},
	mixins: [],
	props: {},
	data() {
		return {};
	},
	computed: {},
	watch: {},
	mounted() {},
	methods: {},
};
</script>
<style lang="" scoped></style>
